import styled from 'styled-components'
import { Badge } from '../../atoms/Badge'

export const DetailHeaderInfo = styled.div`
  flex: 1;
  margin-right: ${({ theme }) => theme.spacing.medium};
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ContentWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  overflow-x: hidden;
  container-type: inline-size;
  container-name: listing-content;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 ${({ theme }) => theme.spacing.medium}
      ${({ theme }) => theme.spacing.large};
  }
`

export const HeroSection = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  overflow: hidden;
  padding: 0 !important;

  @media print {
    overflow: hidden !important;
  }
`

export const QuickInfo = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  padding: ${({ theme }) => theme.spacing.large} 0;
  position: relative;
  z-index: 1;

  @container listing-content (min-width: 500px) {
    padding: ${({ theme }) => theme.spacing.xlarge} 0;
  }
`

export const QuickInfoTop = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing.medium};
  align-items: start;
  margin-bottom: ${({ theme }) => theme.spacing.large};

  @container listing-content (min-width: 500px) {
    grid-template-columns: 1fr auto;
    gap: ${({ theme }) => theme.spacing.large};
  }
`

export const QuickInfoLeft = styled.div`
  flex: 1;
`

export const ListingMetaCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  width: 100%;

  @container listing-content (min-width: 500px) {
    min-width: 180px;
    width: auto;
    flex-shrink: 0;
  }
`

export const ListingMetaItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const ListingMetaLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const ListingMetaValue = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const StatusBadge = styled(Badge)`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
`

export const PropertyTitle = styled.h1`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  word-wrap: break-word;
  overflow-wrap: break-word;

  @container listing-content (min-width: 500px) {
    font-size: ${({ theme }) => theme.typography.fontSize.hero};
  }
`

export const PropertyAddress = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  margin-bottom: ${({ theme }) => theme.spacing.large};

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const UserLinkedAddress = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  margin-bottom: ${({ theme }) => theme.spacing.large};

  svg {
    color: ${({ theme }) => theme.colors.warning};
    flex-shrink: 0;
  }
`

export const UnlinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin-left: ${({ theme }) => theme.spacing.xsmall};
  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.tertiary};
  opacity: 0.6;
  transition: ${({ theme }) => theme.transitions.fast};
  flex-shrink: 0;

  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.colors.danger};
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  svg {
    color: inherit;
  }
`

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.small};
  margin-bottom: ${({ theme }) => theme.spacing.large};

  @container listing-content (min-width: 400px) {
    flex-direction: row;
    align-items: baseline;
    gap: ${({ theme }) => theme.spacing.medium};
  }
`

export const MainPrice = styled.div`
  font-size: 28px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1;

  @container listing-content (min-width: 500px) {
    font-size: 36px;
  }
`

export const PricePerMeter = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing.large};
  margin-top: ${({ theme }) => theme.spacing.xlarge};

  /* Two columns only when container is wide enough */
  @container listing-content (min-width: 700px) {
    grid-template-columns: 1fr 280px;
  }

  @container listing-content (min-width: 900px) {
    grid-template-columns: 1fr 320px;
  }
`

export const LeftColumn = styled.div`
  min-width: 0;
  overflow-wrap: break-word;
  word-wrap: break-word;
`

export const RightColumn = styled.div`
  min-width: 0;

  @container listing-content (min-width: 700px) {
    position: sticky;
    top: ${({ theme }) => theme.spacing.large};
    height: fit-content;
  }
`

export const Description = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  line-height: ${({ theme }) => theme.typography.lineHeight.relaxed};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const MapPreview = styled.div`
  height: 160px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  position: relative;
  overflow: hidden;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  .mapboxgl-ctrl-attrib {
    display: none;
  }

  .mapboxgl-ctrl-logo {
    display: none;
  }
`

export const MapOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

export const FindAddressButton = styled.button`
  background: white;
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  box-shadow: ${({ theme }) => theme.shadows.md};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
`

export const ApproximateLocationBadge = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing.small};
  left: ${({ theme }) => theme.spacing.small};
  z-index: 1;
  background: ${({ theme }) => theme.colors.warningLight};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.warning};
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.small};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ErrorState = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.huge}
    ${({ theme }) => theme.spacing.large};
  color: ${({ theme }) => theme.colors.danger};
`

// Price History Section Styles
export const PriceHistorySection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.large};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing.default};
`

export const PriceHistoryHeader = styled.div<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ $expanded }) => ($expanded ? '12px' : '0')};
  cursor: pointer;
  user-select: none;
  padding: ${({ theme }) => theme.spacing.xsmall} 0;

  &:hover {
    opacity: 0.8;
  }
`

export const PriceHistoryTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  margin: 0;

  svg:first-child {
    color: ${({ theme }) => theme.colors.primary};
  }

  svg:last-child {
    color: ${({ theme }) => theme.colors.text.tertiary};
    margin-left: ${({ theme }) => theme.spacing.xsmall};
  }
`

export const PriceChangeIndicator = styled.span<{ $positive: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 2px ${({ theme }) => theme.spacing.small};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  background: ${({ theme, $positive }) =>
    $positive ? theme.colors.dangerLight : theme.colors.successLight};
  color: ${({ theme, $positive }) =>
    $positive ? theme.colors.danger : theme.colors.success};
  white-space: nowrap;
`

export const PriceHistoryTimeline = styled.div`
  position: relative;
  padding-left: 20px;
  margin-left: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    bottom: 4px;
    width: 1.5px;
    background: ${({ theme }) => theme.colors.border.light};
  }
`

export const PriceHistoryItem = styled.div<{ $isFirst?: boolean }>`
  position: relative;
  padding: ${({ theme }) => theme.spacing.small} 0;

  &:last-child {
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: ${({ $isFirst }) => ($isFirst ? '2px' : '10px')};
    width: ${({ $isFirst }) => ($isFirst ? '10px' : '8px')};
    height: ${({ $isFirst }) => ($isFirst ? '10px' : '8px')};
    border-radius: 50%;
    background: ${({ theme, $isFirst }) =>
      $isFirst ? theme.colors.primary : theme.colors.border.default};
    border: 2px solid ${({ theme }) => theme.colors.background.primary};
    box-shadow: 0 0 0 1.5px
      ${({ theme, $isFirst }) =>
        $isFirst ? theme.colors.primary : theme.colors.border.default};
  }
`

export const PriceHistoryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export const PriceHistoryPrice = styled.span<{ $isFirst?: boolean }>`
  font-size: ${({ theme, $isFirst }) =>
    $isFirst
      ? theme.typography.fontSize.body
      : theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme, $isFirst }) =>
    $isFirst ? theme.colors.primary : theme.colors.text.primary};
`

export const PriceHistoryDate = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const PriceHistoryChange = styled.div<{ $increase: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  color: ${({ theme, $increase }) =>
    $increase ? theme.colors.danger : theme.colors.success};
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 1px;
`
